<template>
  <div class="be-room-filter-bar">
    <p v-if="showResultFilters && isTotalRoomOfferShown" class="be-room-filter-bar__total d-none d-lg-block">
      {{ totalRoomResult }}
    </p>

    <div class="be-room-filter-bar__controls">
      <BePromotionFilterChip class="be-room-filter-bar__promotion" @clear="$emit('clear-promotion')" />

      <div v-if="hasFilterDetail" class="be-room-filter-bar__chip">
        <span class="be-room-filter-bar__chip-label">Show only:</span>
        <span class="be-room-filter-bar__chip-value">{{ getBeFilterDetail.data.name }}</span>
        <button
          type="button"
          class="be-room-filter-bar__chip-clear be-press"
          aria-label="Clear filter"
          @click="$emit('clear-detail')">
          <svg width="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.8 6.21L17.39 4.8L11.8 10.39L6.21 4.8L4.8 6.21L10.39 11.8L4.8 17.39L6.21 18.8L11.8 13.21L17.39 18.8L18.8 17.39L13.21 11.8L18.8 6.21Z" fill="currentColor" />
          </svg>
        </button>
      </div>

      <template v-if="showResultFilters">
        <HotelRoomFilterPrice class="be-room-filter-bar__dropdown" @apply="$emit('filter-change')" />
        <HotelRoomFilterGroupBy class="be-room-filter-bar__dropdown" @select="$emit('filter-change')" />
      </template>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import HotelRoomFilterPrice from '@/components/hotel/be/HotelRoomFilterPrice.vue';
  import HotelRoomFilterGroupBy from '@/components/hotel/be/HotelRoomFilterGroupBy.vue';
  import BePromotionFilterChip from '@/components/hotel/be/v3/BePromotionFilterChip.vue';

  export default {
    name: 'BeRoomFilterBar',
    components: {
      HotelRoomFilterPrice,
      HotelRoomFilterGroupBy,
      BePromotionFilterChip
    },
    props: {
      totalRoomResult: {
        type: String,
        default: ''
      },
      // the digital map lists every room type regardless of budget or grouping,
      // so neither the filters nor the list's offer count apply to it
      showResultFilters: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      ...mapGetters(['getMerchant', 'getBeFilterDetail']),
      hasFilterDetail(){
        return this.$isNotEmptyV2(this.getBeFilterDetail.data);
      },
      // older merchants have no value for this flag, so the summary stays on for them
      isTotalRoomOfferShown(){
        return this.getMerchant.search_room_is_show_total_room_offers !== false;
      }
    }
  }
</script>

<style scoped>
.be-room-filter-bar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  margin-bottom: 16px;
}
.be-room-filter-bar__total {
  margin: 0 auto 0 0;
  font-size: 1.25rem;
  font-weight: 700;
  color: #1a1a2e;
}
.be-room-filter-bar__controls {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  min-width: 0;
}
.be-room-filter-bar__dropdown {
  position: relative;
  z-index: 1021;
}
.be-room-filter-bar__dropdown >>> .border-form.rounded {
  border-radius: var(--be-v3-button-radius, 8px) !important;
  background: #fff;
}
.be-room-filter-bar__chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  padding: 8px 12px;
  border: 1px solid #d5d9e0;
  border-radius: var(--be-v3-button-radius, 8px);
  background: #fff;
  font-size: 0.875rem;
  line-height: 1.4;
}
.be-room-filter-bar__chip-label {
  color: #777;
}
.be-room-filter-bar__chip-value {
  font-weight: 600;
  color: #1a1a2e;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.be-room-filter-bar__chip-clear {
  display: flex;
  margin-left: 4px;
  padding: 0;
  border: none;
  background: transparent;
  color: #222;
  cursor: pointer;
}
@media screen and (max-width: 767.98px) {
  /* the chip takes its own row so a long room type name never squeezes the dropdowns */
  .be-room-filter-bar__controls {
    justify-content: flex-start;
    width: 100%;
  }
  .be-room-filter-bar__chip,
  .be-room-filter-bar__promotion {
    order: 1;
    max-width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/hotel/be/v3/BeRoomFilterBar.vue